import { render, staticRenderFns } from "./label-pc.vue?vue&type=template&id=af08fb32"
import script from "./label-pc.vue?vue&type=script&lang=ts"
export * from "./label-pc.vue?vue&type=script&lang=ts"
import style0 from "./label-pc.vue?vue&type=style&index=0&id=af08fb32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports